module.exports = __webpack_public_path__ + "static/media/profil.6cc17780.svg";